module.exports = __webpack_public_path__ + "static/media/DTD-2026-LOGO.57e2b484.png";